export default "__VITE_ASSET__D0Ln3ndS__"